import { CHART_OBJECT_CATEGORIES } from "./icons";
import { initializeDrawingsStore as initializeFromStore } from "./store";
import type { DrawingCategoryId, DrawingType } from "./types";
import { getDrawingName } from "./registry";

export const initializeChartObjectsStore = () => {
  // Delegates to the store initializer so cross-window storage sync (TS-03)
  // is wired regardless of which init entry point callers use.
  initializeFromStore();
};

export const initializeDrawingsStore = initializeChartObjectsStore;

export const getObjectsByCategory = (
  categoryName: string
): (typeof CHART_OBJECT_CATEGORIES)[number]["objects"] => {
  const category = CHART_OBJECT_CATEGORIES.find(
    (cat) => cat.name === categoryName
  );
  return category?.objects || [];
};

export const getAllObjectTypes = (): DrawingType[] => {
  return CHART_OBJECT_CATEGORIES.flatMap((category) =>
    category.objects.map((obj) => obj.type)
  );
};

export const getObjectName = (type: DrawingType): string => getDrawingName(type);

export const getObjectCategory = (type: DrawingType): string | null => {
  for (const category of CHART_OBJECT_CATEGORIES) {
    const object = category.objects.find((obj) => obj.type === type);
    if (object) {
      return category.name;
    }
  }
  return null;
};

export const getObjectIcon = (type: DrawingType): React.ReactNode => {
  for (const category of CHART_OBJECT_CATEGORIES) {
    const object = category.objects.find((obj) => obj.type === type);
    if (object) {
      return object.icon;
    }
  }
  return null;
};

export type { DrawingCategoryId };
